<template>
  <div class="ele-radio" :class="{ checked: isChecked }" @click="clickRadio"></div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    clickRadio() {
      this.$emit('changeStatus')
    }
  },
  props: { isChecked: Boolean }
}
</script>
<style lang="scss">
.ele-radio {
  width: 14px;
  height: 14px;
  background-image: url('../../assets/imgs/radio_not_checked.png');
  &.checked {
    background-image: url('../../assets/imgs/radio_checked.png');
  }
}
</style>
